/**
 * Retorna enviroment
 * @returns {string} - Ambiente
 */
export default function getEnviroment(): string {
  const { hostname } = window.location;

  const isLocal = !hostname.match(/(^contribua(-develop)?\.(.+)\.(com|org)\.br$)|^app-contribua.+/);

  if (isLocal || hostname.includes('develop')) return 'develop';

  return 'production';
}
